import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const RetirementAssumptions = [
  {
    key: 'RetirementAge',
    title: 'Retirement Age',
    template: value => `${value.Name}: Age ${value.Age}`,
  },
  {
    key: 'RetirementLivingExpenses',
    title: 'Retirement Living Expenses',
    template: ({ amount, frequency }) => `${formatAsCurrency(amount)} ${frequency}`,
  },
  {
    key: 'LifeExpectancy',
    title: 'Life Expectancy',
    template: value => `${value.Name}: Age ${value.Age}`,
  },
  {
    key: 'AdditionalSavingPerMonth',
    title: 'Additional Saving Per Month',
    template: value => `${formatAsCurrency(value)} per month`,
  },
  {
    key: 'PreRetirementAssetAllocation',
    title: 'Pre-Retirement Asset Allocation',
    template: value => value,
  },
  {
    key: 'PreRetirementRateOfReturn',
    title: 'Pre-Retirement Rate of Return',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'PreRetirementStandardDeviation',
    title: 'Pre-Retirement Standard Deviation',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'PostRetirementAssetAllocation',
    title: 'Post-Retirement Asset Allocation',
    template: value => value,
  },
  {
    key: 'PostRetirementRateOfReturn',
    title: 'Post-Retirement Rate of Return',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'PostRetirementStandardDeviation',
    title: 'Post-Retirement Standard Deviation',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'SocialSecurityFilingAge',
    title: 'Social Security Filing Age',
    template: value =>
      `${value.Name}: Age ${value.Age} ${value.MonthsOld ? `& ${value.MonthsOld} months` : ''}`,
  },
  {
    key: 'SocialSecurityAmount',
    title: 'Social Security Amount',
    template: value => `${value.Name}: ${formatAsCurrency(value.Amount)}`,
  },
  {
    key: 'SocialSecurityInflationRate',
    title: 'Social Security Inflation Rate',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'InflationRate',
    title: 'Inflation Rate',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'MarketDrop',
    title: 'Market Drop',
    template: ({ primary, marketDropsNumYears, marketDropsPercentage, marketDropsStartingAge }) => {
      if (marketDropsPercentage === 0) {
        return 'No market drop applied';
      }
      return `${Math.round(marketDropsPercentage * 100 * 100) /
        100}% drop when ${primary} is Age ${marketDropsStartingAge} for ${marketDropsNumYears} Years`;
    },
  },
  {
    key: 'EarmarkedAssets',
    title: 'Earmarked Assets',
    template: value => `Total Earmarked toward this goal ${formatAsCurrency(value)}`,
  },
];

export default RetirementAssumptions;
